import type { FaireProductEntity } from "../../entity_types/product";

export const p_w6rpmvbfs4: FaireProductEntity = {
  token: "p_w6rpmvbfs4",
  type: "product",
  name: "Josie",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/2f71768c9dc273b43a158858a8a645578e1322b5e826943d9bb194fe3b514c3e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/34899c349a83a9b41a86047e91194ef1401eec63cdf8e0d6b2bc0acaca42cf80.jpeg",
    "https://cdn.faire.com/fastly/e1fd52b97cd527d60f88fae502682d33f470f02aad41f2bfb32d21c9de1139a6.jpeg"
  ],
  priceDollars: 25.5,
  description: "Geometry Yoga Towel\n\n♺ Made from post-consumer recycled materials\n\n\n\n\n27”x72”\n\nDesigned in California\n\n\n100% Satisfaction Guarantee\n\nNo questions asked, hassle-free returns\n\n... \n\nFinally, a yoga towel designed to keep your feet — and your practice – grounded. Our Yoga Towel has always been a customer favorite, but now we’ve made it wider and longer so it’s sure to cover your mat with ease. And with more silicone grip on the back, your towel will stay where it should, no matter how sweaty your workout gets. \n\n * 27”x72”\n\n * Ultra absorbent and fast-drying\n\n * Slip-resistant, diamond-patterned silicone underside keeps your towel in place \n * Contrast edging with convenient hang loop \n * Machine washable ",
  tags: [],
  msrpDollars: 51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:58.166Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
